import { type FetchArgs, type FetchBaseQueryArgs } from '@reduxjs/toolkit/dist/query/fetchBaseQuery'
import { type BaseQueryApi, fetchBaseQuery } from '@reduxjs/toolkit/query'
import { showSnackbar } from 'redux/slices/globalState'
import { type ErrorMessageType } from 'types'
import { loadToken } from 'utils/OktaToken'

export const customBaseQuery = (baseQueryOptions: FetchBaseQueryArgs) => async (args: FetchArgs | string, api: BaseQueryApi, extraOptions: Record<string, unknown>) => {
  const token = loadToken()
  if (typeof args === 'string') {
    args = { url: args }
  }
  args.url = cleanUrl(args.url)
  if (token != null) {
    args.headers = { Authorization: `Bearer ${token}` }
  }
  const result = await fetchBaseQuery(baseQueryOptions)(args, api, extraOptions)

  if (result.error != null) {
    const error = result.error
    switch (error.status) {
      case 401:
        window.location.href = '/login'
        break
      case 403:
        api.dispatch(showSnackbar({ message: 'Forbidden action!', status: 'error' }))
        break
      case 404:
        try {
          const errorData = error.data as ErrorMessageType
          api.dispatch(showSnackbar({ message: errorData.message, status: 'error' }))
        } catch {
          api.dispatch(showSnackbar({
            message: `${result.meta!.request.method} ${args.url} not found!`,
            status: 'error'
          }))
        }
        break
      case 'PARSING_ERROR':
        api.dispatch(showSnackbar({ message: `${error.data}`, status: 'error' }))
        break
      default:
        try {
          const errorData = error.data as ErrorMessageType
          api.dispatch(showSnackbar({ message: errorData.message, status: 'error' }))
        } catch {
          api.dispatch(showSnackbar({
            message: `${result.meta!.request.method} ${args.url} unexpected exception!`,
            status: 'error'
          }))
        }
        break
    }
    return { error: { status: error.status, data: error.data } }
  }

  return result
}

const cleanUrl = (old: string) => old.replace(/^\//, '')
